import { RouteProp } from '@react-navigation/native';
import React, { useMemo } from 'react';
import { ProfilesTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import { useMedicalProfileDirectives } from '../../../../../hooks/api/useMedicalProfileDirectives';
import POAFormFields, {
    formValueToUpsertProfilePOARequest,
    getDefaultFromValue,
} from '../../../../shared/Directives/POAFormFields';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import { Form } from '../../../../v2BaseComponents/Form';

export type EditLegalDecisionMakerScreenOwnProps = {};

export type EditLegalDecisionMakerScreenProps = EditLegalDecisionMakerScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'edit-legal-decision-maker'>;
};

const EditLegalDecisionMakerScreen: React.FC<EditLegalDecisionMakerScreenProps> = (props) => {
    const goBack = useGoBack();
    const { isLoadingPOA, poa, updatePOA, isUpdatingPOA } = useMedicalProfileDirectives({
        medicalProfileId: props.route.params.profileId,
        onPOAUpdateSuccess: goBack,
    });
    const initialValue = useMemo(() => getDefaultFromValue(poa), [poa]);
    const isLoading = isLoadingPOA || isUpdatingPOA;

    return (
        <AnimateLoadedContent isLoading={isLoading}>
            {() => (
                <Form
                    fillContainer
                    actionContainerSubmit
                    initialValues={initialValue}
                    onSubmit={(values) => {
                        const upsertRequest = formValueToUpsertProfilePOARequest(values, poa);
                        updatePOA(upsertRequest);
                    }}
                    onCancel={goBack}
                >
                    {({ values }) => <POAFormFields values={values} />}
                </Form>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(EditLegalDecisionMakerScreen);
